<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet {{sectionclass}}">
        <div class="cards-holder devices-tab">
            <div class="card card2 mRight devices-card">
                <app-loader [showLoader]=showLoad></app-loader>
                <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
                    <div class="o-stack__cell">
                        <h5 class="card-title">{{sectiontitle}}</h5>
                        <span class="datatable-icon" *ngIf="hasData">
                            <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSVData($event)" target="_blank" *ngIf="devicedatatableconfig && devicedatatableconfig.enableDownload">
                                <i class="fa fa-download" aria-hidden="true"></i>
                            </a>
                        </span>
                    </div>
                </div>
                <div class="" *ngIf="hasData">
                    <ngx-datatable class="datatable" [rows]="dataTableObj.data" [columns]="dataTableObj.columns" [sortType]="'single'" [columnMode]="'force'"
                                   [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10" [reorderable]="reorderable">
                        <ng-template  ngFor let-column [ngForOf]="dataTableObj.columns">
                            <ngx-datatable-column name="{{column.name}}" prop="{{column.prop}}" [resizeable]="false" [sortable]="true" [cellClass]="column.cellClass" [headerClass]="column.headerClass" [comparator]="column.comparator">
                                <ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
                            <span (click)="sortData(column.name)" class="data_table_cursor" *ngIf="!column.columnHasTooltip; else elseBlock">
                                {{colHeader.name}}
                            </span>
                                    <ng-template #elseBlock>
                                <span class="data_table_cursor">
                                    <span (click)="sortData(column.name)" appTooltip title="Tooltip" [title]="column.columnTooltip" data-size="big"
                                          [options]="tooltipOptions">
                                       {{colHeader.name}}
                                    </span>
                                </span>
                                    </ng-template>
                                </ng-template>
                            </ngx-datatable-column>
                        </ng-template>
                    </ngx-datatable>
                </div>
                <div class="no-data-container no-container" *ngIf="!hasData">
                    <div class="map-no-data">No Data to Display</div>
                </div>
            </div>
            <div class="card card2 mLeft devices-carousel">
                <app-loader [showLoader]=showLoad></app-loader>
                <div class="c-portlet__header">
                    <div class="o-stack__cell">
                        <h5>Device Breakdown</h5>
                    </div>
                </div>
                <div id="pie-donut-graph-container" *ngIf="hasData">
                    <app-donut [chartData]="chartArrData"
                        [chartConfigurationObj]="chartConfigObj"></app-donut>
                </div>
                <div class="no-data-container no-container" *ngIf="!hasData">
                    <div class="map-no-data">No Data to Display</div>
                </div>
            </div>
        </div>
    </div>
